var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#5DC1D8"
    },
    cx: 250.5,
    cy: 267,
    r: 245
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9EAFC"
    },
    d: "M272.5,511c-4.962,0-9-4.037-9-9V227.67c0-4.963,4.038-9,9-9h125.053V5c0-2.75-2.25-5-5-5H108.447 c-2.75,0-5,2.25-5,5v40.771c36.041,3.558,64.292,34.039,64.292,71s-28.251,67.443-64.292,71.002V462.97 C144.404,493.753,195.32,512,250.5,512c7.469,0,14.856-0.346,22.154-1H272.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C3DDF4"
    },
    d: "M103.447,187.773V462.97c6.379,4.795,13.001,9.285,19.842,13.45V182.842 C117.061,185.388,110.402,187.086,103.447,187.773z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C3DDF4"
    },
    d: "M123.289,50.702V5c0-2.75,2.25-5,5-5h-19.842c-2.75,0-5,2.25-5,5v40.771 C110.402,46.457,117.061,48.156,123.289,50.702z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EB7FF"
    },
    d: "M273.682,87.033H161.221c2.186,4.746,3.875,9.765,4.979,15h107.483c4.142,0,7.5-3.357,7.5-7.5 C281.182,90.391,277.824,87.033,273.682,87.033z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EB7FF"
    },
    d: "M273.682,111.031H167.487c0.152,1.896,0.251,3.807,0.251,5.74c0,3.14-0.226,6.227-0.621,9.26 h106.564c4.142,0,7.5-3.358,7.5-7.5C281.182,114.389,277.824,111.031,273.682,111.031z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EB7FF"
    },
    d: "M273.682,135.029H165.361c-1.395,5.263-3.38,10.285-5.875,15h114.196c4.142,0,7.5-3.357,7.5-7.5 C281.182,138.387,277.824,135.029,273.682,135.029z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EB7FF"
    },
    d: "M273.682,159.027H153.836c-4.201,5.696-9.221,10.752-14.895,14.98 c0.125,0.007,0.249,0.02,0.376,0.02h134.364c4.142,0,7.5-3.357,7.5-7.5C281.182,162.385,277.824,159.027,273.682,159.027z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EB7FF"
    },
    d: "M273.682,198.025H139.318c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h134.364 c4.142,0,7.5,3.357,7.5,7.5S277.824,198.025,273.682,198.025z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F87EAB"
    },
    d: "M356,102.033h-55.308c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5H356c4.142,0,7.5,3.357,7.5,7.5 C363.5,98.676,360.142,102.033,356,102.033z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F87EAB"
    },
    d: "M356,126.031h-55.308c-4.142,0-7.5-3.358-7.5-7.5c0-4.143,3.358-7.5,7.5-7.5H356 c4.142,0,7.5,3.357,7.5,7.5C363.5,122.674,360.142,126.031,356,126.031z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F87EAB"
    },
    d: "M356,150.029h-55.308c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5H356c4.142,0,7.5,3.357,7.5,7.5 C363.5,146.672,360.142,150.029,356,150.029z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F87EAB"
    },
    d: "M356,174.027h-55.308c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5H356c4.142,0,7.5,3.357,7.5,7.5 S360.142,174.027,356,174.027z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F87EAB"
    },
    d: "M356,198.025h-55.308c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5H356c4.142,0,7.5,3.357,7.5,7.5 S360.142,198.025,356,198.025z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EB7FF"
    },
    d: "M263.5,231.021H141.755c-4.142,0-7.5,3.357-7.5,7.5s3.358,7.5,7.5,7.5H263.5V231.021z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EB7FF"
    },
    d: "M263.5,255.02H141.755c-4.142,0-7.5,3.358-7.5,7.5c0,4.143,3.358,7.5,7.5,7.5H263.5V255.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EB7FF"
    },
    d: "M263.5,279.018H141.755c-4.142,0-7.5,3.357-7.5,7.5s3.358,7.5,7.5,7.5H263.5V279.018z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EB7FF"
    },
    d: "M263.5,303.016H141.755c-4.142,0-7.5,3.357-7.5,7.5s3.358,7.5,7.5,7.5H263.5V303.016z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EB7FF"
    },
    d: "M263.5,327.014H141.755c-4.142,0-7.5,3.357-7.5,7.5s3.358,7.5,7.5,7.5H263.5V327.014z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EB7FF"
    },
    d: "M263.5,375.01H141.755c-4.142,0-7.5,3.357-7.5,7.5s3.358,7.5,7.5,7.5H263.5V375.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EB7FF"
    },
    d: "M263.5,399.008H141.755c-4.142,0-7.5,3.357-7.5,7.5s3.358,7.5,7.5,7.5H263.5V399.008z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EB7FF"
    },
    d: "M263.5,423.006H141.755c-4.142,0-7.5,3.357-7.5,7.5s3.358,7.5,7.5,7.5H263.5V423.006z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EB7FF"
    },
    d: "M263.5,447.004H141.755c-4.142,0-7.5,3.357-7.5,7.5s3.358,7.5,7.5,7.5H263.5V447.004z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E99D6"
    },
    d: "M506.5,502c0,5.5-4.5,10-10,10h-224c-5.5,0-10-4.5-10-10V227.67c0-5.5,4.5-10,10-10h224 c5.5,0,10,4.5,10,10V502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E99D6"
    },
    d: "M282.342,502V227.67c0-5.5,4.5-10,10-10H272.5c-5.5,0-10,4.5-10,10V502c0,5.5,4.5,10,10,10h19.842 C286.842,512,282.342,507.5,282.342,502z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91E0E8"
    },
    d: "M489.5,307.792c0,2.75-2.25,5-5,5h-200c-2.75,0-5-2.25-5-5v-47.235c0-2.75,2.25-5,5-5h200 c2.75,0,5,2.25,5,5V307.792z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91E0E8"
    },
    d: "M302,307.792v-47.235c0-2.75,2.25-5,5-5h-22.5c-2.75,0-5,2.25-5,5v47.235c0,2.75,2.25,5,5,5H307 C304.25,312.792,302,310.542,302,307.792z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M314.839,353.524c0,2.75-2.25,5-5,5H284.5c-2.75,0-5-2.25-5-5v-24.319c0-2.75,2.25-5,5-5h25.339 c2.75,0,5,2.25,5,5V353.524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M358.504,353.524c0,2.75-2.25,5-5,5h-25.338c-2.75,0-5-2.25-5-5v-24.319c0-2.75,2.25-5,5-5h25.338 c2.75,0,5,2.25,5,5V353.524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M402.169,353.524c0,2.75-2.25,5-5,5H371.83c-2.75,0-5-2.25-5-5v-24.319c0-2.75,2.25-5,5-5h25.339 c2.75,0,5,2.25,5,5V353.524z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EB7FF"
    },
    d: "M445.835,353.524c0,2.75-2.25,5-5,5h-25.338c-2.75,0-5-2.25-5-5v-24.319c0-2.75,2.25-5,5-5h25.338 c2.75,0,5,2.25,5,5V353.524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EB7FF"
    },
    d: "M489.5,353.524c0,2.75-2.25,5-5,5h-25.339c-2.75,0-5-2.25-5-5v-24.319c0-2.75,2.25-5,5-5H484.5 c2.75,0,5,2.25,5,5V353.524z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M314.839,397.524c0,2.75-2.25,5-5,5H284.5c-2.75,0-5-2.25-5-5v-24.319c0-2.75,2.25-5,5-5h25.339 c2.75,0,5,2.25,5,5V397.524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M358.504,397.524c0,2.75-2.25,5-5,5h-25.338c-2.75,0-5-2.25-5-5v-24.319c0-2.75,2.25-5,5-5h25.338 c2.75,0,5,2.25,5,5V397.524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M402.169,397.524c0,2.75-2.25,5-5,5H371.83c-2.75,0-5-2.25-5-5v-24.319c0-2.75,2.25-5,5-5h25.339 c2.75,0,5,2.25,5,5V397.524z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EB7FF"
    },
    d: "M445.835,397.524c0,2.75-2.25,5-5,5h-25.338c-2.75,0-5-2.25-5-5v-24.319c0-2.75,2.25-5,5-5h25.338 c2.75,0,5,2.25,5,5V397.524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EB7FF"
    },
    d: "M489.5,397.524c0,2.75-2.25,5-5,5h-25.339c-2.75,0-5-2.25-5-5v-24.319c0-2.75,2.25-5,5-5H484.5 c2.75,0,5,2.25,5,5V397.524z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M314.839,441.524c0,2.75-2.25,5-5,5H284.5c-2.75,0-5-2.25-5-5v-24.319c0-2.75,2.25-5,5-5h25.339 c2.75,0,5,2.25,5,5V441.524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M358.504,441.524c0,2.75-2.25,5-5,5h-25.338c-2.75,0-5-2.25-5-5v-24.319c0-2.75,2.25-5,5-5h25.338 c2.75,0,5,2.25,5,5V441.524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M402.169,441.524c0,2.75-2.25,5-5,5H371.83c-2.75,0-5-2.25-5-5v-24.319c0-2.75,2.25-5,5-5h25.339 c2.75,0,5,2.25,5,5V441.524z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EB7FF"
    },
    d: "M445.835,441.524c0,2.75-2.25,5-5,5h-25.338c-2.75,0-5-2.25-5-5v-24.319c0-2.75,2.25-5,5-5h25.338 c2.75,0,5,2.25,5,5V441.524z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M314.839,485.524c0,2.75-2.25,5-5,5H284.5c-2.75,0-5-2.25-5-5v-24.319c0-2.75,2.25-5,5-5h25.339 c2.75,0,5,2.25,5,5V485.524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M358.504,485.524c0,2.75-2.25,5-5,5h-25.338c-2.75,0-5-2.25-5-5v-24.319c0-2.75,2.25-5,5-5h25.338 c2.75,0,5,2.25,5,5V485.524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M402.169,485.524c0,2.75-2.25,5-5,5H371.83c-2.75,0-5-2.25-5-5v-24.319c0-2.75,2.25-5,5-5h25.339 c2.75,0,5,2.25,5,5V485.524z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EB7FF"
    },
    d: "M445.835,485.524c0,2.75-2.25,5-5,5h-25.338c-2.75,0-5-2.25-5-5v-24.319c0-2.75,2.25-5,5-5h25.338 c2.75,0,5,2.25,5,5V485.524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3EB7FF"
    },
    d: "M459.161,412.205c-2.75,0-5,2.25-5,5v68.319c0,2.75,2.25,5,5,5H484.5c2.75,0,5-2.25,5-5v-68.319 c0-2.75-2.25-5-5-5H459.161z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M427.833,228.89c-1.65,0-3,1.35-3,3v11.398c0,1.65,1.35,3,3,3H486.5c1.65,0,3-1.35,3-3V231.89 c0-1.65-1.35-3-3-3H427.833z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9EAFC"
    },
    d: "M444.675,243.288V231.89c0-1.65,1.35-3,3-3h-19.842c-1.65,0-3,1.35-3,3v11.398c0,1.65,1.35,3,3,3 h19.842C446.025,246.288,444.675,244.939,444.675,243.288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#445EA0"
    },
    d: "M360.5,41H140.501c-1.65,0-3,1.35-3,3v14.51c5.042,3.569,9.607,7.766,13.568,12.49H360.5 c1.65,0,3-1.35,3-3V44C363.5,42.35,362.149,41,360.5,41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#293D7C"
    },
    d: "M151.068,71h15.617c-1.65,0-3-1.35-3-3V44c0-1.65,1.35-3,3-3H140.5c-1.65,0-3,1.35-3,3v14.51 C142.542,62.079,147.107,66.275,151.068,71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DC1D8"
    },
    d: "M467.5,308.5h-10c-6.893,0-12.5-5.607-12.5-12.5v-22c0-6.893,5.607-12.5,12.5-12.5h10 c6.893,0,12.5,5.607,12.5,12.5v22C480,302.893,474.393,308.5,467.5,308.5z M460,293.5h5v-17h-5V293.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EF9614"
    },
    cx: 96.39,
    cy: 116.77,
    r: 72.35
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD00D"
    },
    cx: 96.39,
    cy: 116.77,
    r: 51.42
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF10"
    },
    d: "M64.805,116.771c0-25.005,17.85-45.831,41.501-50.455c-3.211-0.628-6.526-0.966-9.921-0.966 c-28.4,0-51.422,23.021-51.422,51.421s23.021,51.424,51.422,51.424c3.395,0,6.71-0.338,9.921-0.966 C82.655,162.605,64.805,141.777,64.805,116.771z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB722C"
    },
    d: "M106.487,109.532H89.896v-4.688h20.477c4.142,0,7.5-3.358,7.5-7.5c0-4.143-3.358-7.5-7.5-7.5h-6.488 v-3.379c0-4.142-3.358-7.5-7.5-7.5s-7.5,3.358-7.5,7.5v3.379h-2.603c-6.278,0-11.386,5.108-11.386,11.387v11.916 c0,6.278,5.108,11.386,11.386,11.386h16.591v4.686H82.396c-4.142,0-7.5,3.357-7.5,7.5s3.358,7.5,7.5,7.5h6.489v2.862 c0,4.143,3.358,7.5,7.5,7.5s7.5-3.357,7.5-7.5v-2.862h2.602c6.278,0,11.386-5.107,11.386-11.386v-11.915 C117.873,114.64,112.766,109.532,106.487,109.532z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBill);
export default __webpack_public_path__ + "static/media/bill.f72dbd805391149d433ae627a6ff1e10.svg";
export { ForwardRef as ReactComponent };